import React from 'react';
import { useHistory } from 'react-router-dom';

const SponsorDetails = () => {
    const history = useHistory();
    return (
        <React.Fragment>
            <div className="p-3">
                <div className="card p-3 border-none box-shadow">
                    <div className="pageHeading">
                        <i className="fa fa-arrow-left backBtn" onClick={() => history.goBack()}></i>
                        <h4 className="text-center">Sponsor Details</h4>
                    </div>
                </div>
                <div className="card p-3 border-none box-shadow">
                    <div className="fullSponsor">
                        <img src={process.env.PUBLIC_URL + '/images/top-brand-1.png'} alt="" className="fullWidth" />
                    </div>
                </div>
                <div className="card p-3 border-none box-shadow">
                    <div className="justify-content-between align-items-center d-flex mb-3">
                        <p className="m-0">Booth: 119-121</p>
                        <ul className="listInline m-0">
                            <li><i class="fa fa-star"></i></li>
                            <li><i class="fa fa-check"></i></li>
                            <li><i class="fa fa-pencil"></i></li>
                            <li><i class="fa fa-calendar"></i></li>
                        </ul>
                    </div>
                    <div className="content">
                        <h3>Section Heading</h3>
                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                        <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
                    </div>
                </div>
                <div className="card p-3 border-none box-shadow">
                    <div className="content">
                        <h3>Contact</h3>
                    </div>
                    <ul className="unOrderList">
                        <li>Name</li>
                        <li>Title</li>
                        <li><a href="#" >email@ymail.com</a></li>
                        <li><a href="#" >email@ymail.com</a></li>
                    </ul>
                </div>
            </div>
        </React.Fragment>
    )
}
export default SponsorDetails;